import { Button } from '@mui/material';
import { styled } from '@mui/system';

export const StyledPKDFilledButton = styled(Button)(
  ({ theme, width, height, sx }) => {
    const backgroundColor = sx?.backgroundColor;
    const color = sx?.color;
    return {
      ...sx,
      backgroundColor : backgroundColor || theme.palette.primary.blue1,
      color           : color || theme.palette.primary.white,
      borderRadius    : '8px',
      padding         : '15px 15px 15px 15px',
      width           : width || 295,
      height          : height || 45,
      fontWeight      : 'bold',
      fontFamily      : 'Montserrat',
      textTransform   : 'none',
      '&:hover'       : {
        opacity         : 0.8,
        backgroundColor : backgroundColor || theme.palette.primary.blue1,
      },
      '&.Mui-disabled' : {
        color   : color || theme.palette.primary.white,
        opacity : 0.6,
        cursor  : 'no-allowed !important',
      },
    };
  }
);
